import {useDates} from "@App/hooks/useDates";
import {useMutation} from "@apollo/client";
import {BLOCK_SLOT, BlockSlotQuery} from "@App/graphql/mutations/blockSlot";
import {useState} from "react";
import {Slot} from "@App/types";
import {useCalculation} from "@App/hooks/useCalculation";

export const useBlockSlot = () => {

    const {
        organization,
        service,
        garage,
        filterBrand,
        brand,
        generation,
        motorization,
        body,
        gearbox,
        mileage,
        initialRegistrationDate,
        subRepairs,
        equipments,
        premiumServices
    } = useCalculation()

    const [triedSlot, setTriedSlot] = useState<Slot|null>(null)
    const {toIsoString, formatDate} = useDates()

    const [block, {loading, data, error}] = useMutation<BlockSlotQuery>(BLOCK_SLOT)

    const blockSlot = (slot: Slot) => {
        setTriedSlot(slot)

        block({
            variables: {
                organization: organization ? organization.id : null,
                garage: garage ? garage.id : null,
                calendarId: slot.calendar_id,
                services: service ? [service.id] : null,
                startDate: slot ? toIsoString(slot.starts_at) : null,
                endDate: slot && slot.ends_at ? toIsoString(slot.ends_at) : null,
                brand: brand
                    ? brand.id
                    : filterBrand
                        ? filterBrand.id
                        : null,
                generation: generation ? generation.id : null,
                motorization: motorization ? motorization.id : null,
                body: body ? body.id : null,
                gearbox: gearbox ? gearbox.id : null,
                mileage: mileage,
                // TODO: withCalculation: organization.settings.garage_list.display_prices ?? false,
                withCalculation: true,
                registrationDate: initialRegistrationDate ? formatDate(initialRegistrationDate, 'yyyy-MM-dd') : null,
                premiumServices: premiumServices && premiumServices.length > 0 ? premiumServices.map((p) => p.id) : null,
                equipments: equipments && equipments.map(equipment => equipment.name),
                subRepairs: subRepairs,
                session_id: slot && slot.session_id ? slot.session_id : null
            }
        })
    }

    return {
        error,
        loading,
        triedSlot,
        blockedSlot: data ? data.block : null,
        blockSlot
    }
}
